// extracted by mini-css-extract-plugin
export default {"header":"FavoriteModelsDropZone_header__mWOsM","icon":"FavoriteModelsDropZone_icon__MHTpt","body":"FavoriteModelsDropZone_body__em1M9"};